import React, { useEffect, useState } from 'react'
import { BsBuildings, BsCalendar2Check, BsGrid3X3Gap, BsStarFill } from 'react-icons/bs';
import adminServices from '../../services/AdminServices';

function Summary() {
    const [statistics, setStatistics] = useState()
    const getStats = () => {
        adminServices.propertyStatatistics().then(
            res => {
                setStatistics(res.data)
            },
            err => {
                console.log(err);
            }
        )
    }
    useEffect(() => {
        getStats()
    },[])
    return (
        <section className="grid grid-cols-12 gap-6">
            <div className="col-span-12 lg:col-span-3 p-8 bg-white border border-outline-variant rounded-xl group hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start justify-between mb-4">
                    <p className="text-[10px] font-label font-bold uppercase tracking-[0.2em] text-on-surface-variant/60">
                        Total Bookings
                    </p>
                    <BsCalendar2Check className="text-2xl text-primary/70 group-hover:text-primary transition-colors" />
                </div>
                <h3 className="text-4xl font-headline text-primary">{statistics?.bookings}</h3>
            </div>

            <div className="col-span-12 lg:col-span-3 p-8 bg-white border border-outline-variant rounded-xl group hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start justify-between mb-4">
                    <p className="text-[10px] font-label font-bold uppercase tracking-[0.2em] text-on-surface-variant/60">
                        Total Units
                    </p>
                    <BsBuildings className="text-2xl text-primary/70 group-hover:text-primary transition-colors" />
                </div>
                <h3 className="text-4xl font-headline text-primary">{statistics?.properties}</h3>
            </div>

            <div className="col-span-12 lg:col-span-3 p-8 bg-white border border-outline-variant rounded-xl group hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start justify-between mb-4">
                    <p className="text-[10px] font-label font-bold uppercase tracking-[0.2em] text-on-surface-variant/60">
                        Active Categories
                    </p>
                    <BsGrid3X3Gap className="text-2xl text-primary/70 group-hover:text-primary transition-colors" />
                </div>
                <h3 className="text-4xl font-headline text-primary">{statistics?.categories}</h3>
            </div>

            <div className="col-span-12 lg:col-span-3 p-8 bg-white border border-outline-variant rounded-xl group hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-start justify-between mb-4">
                    <p className="text-[10px] font-label font-bold uppercase tracking-[0.2em] text-on-surface-variant/60">
                        Premier Amenities
                    </p>
                    <BsStarFill className="text-2xl text-primary/70 group-hover:text-primary transition-colors" />
                </div>
                <h3 className="text-4xl font-headline text-primary">{statistics?.amenities}</h3>
            </div>
        </section>
    )
}

export default Summary